import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import PropTypes from "prop-types";
import "./UsernameSearchSuggestions.css";

/**
 * Component that displays username suggestions when a profile search fails
 */
const UsernameSearchSuggestions = ({ suggestions, onSuggestionClick }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <Card className="username-suggestions-card">
      <CardBody>
        <h5 className="suggestions-title">
          <i className="fas fa-search mr-2"></i> Did you mean:
        </h5>
        <ul className="suggestions-list">
          {suggestions.map((username, index) => (
            <li key={index} className="suggestion-item">
              <Link 
                to={`/playerprofile?user=${encodeURIComponent(username)}`}
                className="suggestion-link"
                onClick={() => onSuggestionClick(username)}
              >
                {username}
              </Link>
            </li>
          ))}
        </ul>
      </CardBody>
    </Card>
  );
};

UsernameSearchSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  onSuggestionClick: PropTypes.func.isRequired
};

export default UsernameSearchSuggestions;
